// extracted by mini-css-extract-plugin
export default {"slideModal":"SlideModal_slideModal__hN5j0"};